import { CopyWhiteImage } from '../../svgImages/CopyImage';
import { NewTabWhiteImage } from '../../svgImages/NewTabImage';
import { PlayWhiteImage } from '../../svgImages/PlayImage';
import { PlusWhiteImage } from '../../svgImages/PlusImage';
import { PurchaseWhiteImage } from '../../svgImages/PurchaseImage';
import { ShareWhiteImage } from '../../svgImages/ShareImage';
import type { ButtonProps } from '../types';

export const ButtonPrimary: React.FC<
  ButtonProps & {
    prefixIcon?: 'plus' | 'purchase' | 'newTab' | 'share' | 'copy' | 'play';
  }
> = ({ text, width, prefixIcon = null, isLoading = false, ...attr }) => (
  <button
    type="button"
    className={
      width === 'fit'
        ? 'group relative flex min-h-10 w-fit appearance-none items-center justify-center rounded-2 p-3'
        : 'group relative flex min-h-10 w-full appearance-none items-center justify-center rounded-2 p-3'
    }
    {...attr}
  >
    <div className="absolute inset-0 rounded-2 bg-accent-primary transition-[filter] hover:brightness-110" />
    {isLoading && (
      <div className="absolute inset-y-0 right-2 my-auto size-4">
        <div className="size-full animate-spin rounded-[50%] border-2 border-b-base-40 border-l-base-100 border-r-base-40 border-t-base-100" />
      </div>
    )}
    <div className="relative flex w-fit items-center gap-1">
      {prefixIcon === 'plus' && <PlusWhiteImage alt="" className="size-4" />}
      {prefixIcon === 'purchase' && (
        <PurchaseWhiteImage alt="" className="size-4" />
      )}
      {prefixIcon === 'newTab' && (
        <NewTabWhiteImage alt="" className="size-4" />
      )}
      {prefixIcon === 'share' && <ShareWhiteImage alt="" className="size-4" />}
      {prefixIcon === 'copy' && <CopyWhiteImage alt="" className="size-4" />}
      {prefixIcon === 'play' && <PlayWhiteImage alt="" className="size-4" />}
      <div className="cst-button-label-text text-base-100">{text}</div>
    </div>
  </button>
);
